import axios from "axios";
import { EnvironmentPropDTO } from "../dto/EnvironmentPropDTO";

var CREATOR_URL = process.env.REACT_APP_PLAYIT_CREATORAPI;

export class EnvironmentManagementService {
  static async SaveEnvironment(
    orgId: string,
    token: string,
    environmentId: string,
    content: string
  ) {
    const path =
      "/organizations/" + orgId + "/environments/" + environmentId + "/content";
    const url = CREATOR_URL + path;
    const config = getConfig(token);

    const formData = new FormData();
    formData.append(
      "File",
      new Blob([content], { type: "application/json" }),
      "file.json"
    );

    const multipartConfig = {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    };

    const { status } = await axios.post(url, formData, multipartConfig);
    return status === 201;
  }

  static async SaveEnvironmentProps(
    orgId: string,
    token: string,
    environmentId: string,
    environmentProps: EnvironmentPropDTO[]
  ) {
    const path =
      "/mgmt/organizations/" +
      orgId +
      "/environments/" +
      environmentId +
      "/environmentProps";
    const url = CREATOR_URL + path;
    const config = getConfig(token);

    const jsonPatchConfig = {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "application/json-patch+json",
      },
    };

    const { status } = await axios.patch(url, environmentProps, jsonPatchConfig);
    return status === 204;
  }
}

// === Helper functions ===
// create config w/ auth for api calls
const getConfig = (token: string) => {
  return {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
};
